import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card } from '@medikei/ui';
import { Clock, LogIn, Home, ArrowLeft } from 'lucide-react';
import { httpClient } from '@/api';

export function SessionExpiredPage() {
  useEffect(() => {
    // Actively clear any stale access token from localStorage upon reaching this page
    httpClient.logout();
  }, []);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-primary/5 via-background to-background p-4 text-foreground">
      <Card className="p-8 max-w-md w-full text-center border border-border/80 shadow-xl shadow-primary/5 rounded-2xl">
        <div className="w-16 h-16 rounded-2xl bg-amber-100 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 flex items-center justify-center mx-auto mb-5 shadow-sm">
          <Clock size={32} />
        </div>
        <h1 className="text-2xl font-bold text-foreground mb-2">
          Sessão Expirada
        </h1>
        <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
          Sua sessão expirou por inatividade ou tempo limite de segurança.
          Por favor, faça login novamente para continuar usando sua conta.
        </p>

        <div className="space-y-3">
          <Link to="/login" className="w-full block">
            <Button variant="primary" size="md" className="w-full rounded-xl font-semibold gap-2">
              <LogIn size={18} />
              Fazer Login
            </Button>
          </Link>

          <Link to="/" className="w-full block">
            <Button variant="outline" size="md" className="w-full rounded-xl font-semibold gap-2">
              <Home size={18} />
              Ir para a Página Inicial
            </Button>
          </Link>
        </div>

        <div className="mt-6 pt-4 border-t border-border/60">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors font-medium"
          >
            <ArrowLeft size={14} />
            Voltar para o site da Medikei
          </Link>
        </div>
      </Card>
    </div>
  );
}
